'use client'

import BaseModal from '@components/BaseModal'
import { UserListInterface } from '@hermes/types'
import useTranslateMessage from '@hooks/useTranslateMessage'
import { useUserToken } from '@hooks/useUserToken'
import { fetchUserLists } from '@lib/services/user'
import getRegionFromLocale from '@lib/utils/getRegionFromLocale'
import { useEffect, useState } from 'react'

import { useLocale } from '@hooks/useLocale'
import AddToListRoute from './Add'
import CreateListRoute from './Create'
import MainRoute from './Main'

interface AddToWishlistProps {
  isOpen: boolean
  onClose: () => void
  bookId: number
}

const AddToWishlist = ({ isOpen, onClose, bookId }: AddToWishlistProps) => {
  const [modalRoute, setModalRoute] = useState('main')
  const [listId, setListId] = useState<undefined | number>(undefined)
  const [lists, setLists] = useState<UserListInterface[]>([])
  const { token } = useUserToken()
  const locale = useLocale()
  const region = getRegionFromLocale(locale)
  const { t } = useTranslateMessage()

  useEffect(() => {
    if (isOpen)
      fetchUserLists({
        token: String(token),
        country: region.toUpperCase()
      }).then((resp) => setLists(resp.data.array))
  }, [isOpen])

  const onCloseHandler = () => {
    setModalRoute('main')
    setListId(0)
    onClose()
  }

  return (
    <BaseModal
      backButton={modalRoute !== 'main'}
      backAction={() => setModalRoute('main')}
      isOpen={isOpen}
      title={t({ id: 'modal.addBookToList.title' })}
      width={400}
      onClose={() => {
        setModalRoute('main')
        onCloseHandler()
      }}
    >
      <>
        {modalRoute === 'main' && <MainRoute setListId={setListId} setRoute={setModalRoute} lists={lists} />}
        {modalRoute === 'create' && <CreateListRoute setRoute={setModalRoute} lists={lists} setLists={setLists} />}
        {modalRoute === 'add' && <AddToListRoute onClose={onCloseHandler} listId={listId} bookId={bookId} />}
      </>
    </BaseModal>
  )
}

export default AddToWishlist
